namespace GeniuzPOS.Inventory {
    export class IcStockCountCodeColumns {
        static columnsKey = 'Inventory.IcStockCountCode';
    }
}
